import { render, staticRenderFns } from "./productMasterFieldLanguages.vue?vue&type=template&id=736dfc2a&scoped=true&"
import script from "./productMasterFieldLanguages.vue?vue&type=script&lang=js&"
export * from "./productMasterFieldLanguages.vue?vue&type=script&lang=js&"
import style0 from "./productMasterFieldLanguages.vue?vue&type=style&index=0&id=736dfc2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736dfc2a",
  null
  
)

/* custom blocks */
import block0 from "./productMasterFieldLanguages.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VChipGroup,VTextField})
